module.exports = __webpack_public_path__ + "media/images/weather/34_night-488188c9955ac3060fdb714b453066c3.png";